import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Cambiar useRouter por useNavigate y useLocation
import EventList from '../components/event/EventList';
import EventRegistration from '../components/event/EventRegistration';
import { Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const EventsPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate(); // Usar useNavigate en lugar de useRouter
  const location = useLocation();

  // Estados deben declararse antes de cualquier retorno condicional
  const [events, setEvents] = useState([
    { id: 1, name: 'Carrera local', location: 'Algún lugar', date: new Date().toISOString() },
    { id: 2, name: 'Maratón', location: 'Otro lugar', date: new Date().toISOString() },
  ]);

  const [registeredEvents, setRegisteredEvents] = useState([]);

  // Redirigir si el usuario no está autenticado
  useEffect(() => {
    if (!user) {
      navigate('/auth/login'); // Usar navigate para redirigir
    }
  }, [user, navigate]);

  // Si no hay usuario, no renderizar nada
  if (!user) {
    return null;
  }

  const handleRegister = (id) => {
    const eventToRegister = events.find((event) => event.id === id);
    if (eventToRegister) {
      setRegisteredEvents([...registeredEvents, eventToRegister]);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ p: 3, width: '100%' }}>
          <EventList events={events} handleRegister={handleRegister} />
          <EventRegistration registeredEvents={registeredEvents} />
        </Box>
      </Box>
    </>
  );
};

export default EventsPage;